import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'numberShortNotation',
    standalone: false
})
export class NumberShortNotation implements PipeTransform {

    transform(number: number): any {
        if (number > 1000) {
            return (number/1000).toFixed(1) + 'K'
        } else {
            return number;
        }
    }
}